import { render, staticRenderFns } from "./ListingDetailsLivestock.vue?vue&type=template&id=10a66a60&scoped=true"
import script from "./ListingDetailsLivestock.vue?vue&type=script&lang=js"
export * from "./ListingDetailsLivestock.vue?vue&type=script&lang=js"
import style0 from "./ListingDetailsLivestock.vue?vue&type=style&index=0&id=10a66a60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a66a60",
  null
  
)

export default component.exports